// 모바일 API — 기존 frontend/src/api/ 함수 재사용
import axiosInstance from '../../api/axiosInstance';

export { fetchAccounts }                   from '../../api/accounts';
export {
  fetchPortfolioSummary,
  fetchPeriodChart,
  fetchPortfolioHoldings,
  fetchHoldingsDetail,
  fetchPeriodDetail,
  fetchPeriodEval,
} from '../../api/portfolio';
export { fetchTurnStatus }                 from '../../api/profit';
export { fetchRealtimePrices }             from '../../api/price';
export { default as axiosInstance }        from '../../api/axiosInstance';

// 모바일 전용: 종목별 시세 이력 조회
export const fetchStockChart = async (ticker, period = '3m') => {
  const res = await axiosInstance.get('/mobile/stock-chart', {
    params: { ticker, period },
  });
  return res.data;
};
